class CollectionMethodSelector {
    constructor(containerSelector, defaultSku = null) {
        this.container = document.querySelector(containerSelector);
        this.cards = this.container.querySelectorAll('.collection-method-card');
        this.defaultSku = defaultSku; // SKU value from metafield
        this.init();
    }

    init() {
        this.cards.forEach(card => {
            card.addEventListener('click', () => this.selectCard(card));
        });
        this.selectDefaultCard();
    }

    selectCard(card) {
        // Remove 'selected' class from all cards
        this.cards.forEach(c => c.classList.remove('selected'));

        // Add 'selected' class to the clicked card
        card.classList.add('selected');
    }

    selectDefaultCard() {
        let defaultCard = null;

        // Check if a SKU was provided in the metafield
        if (this.defaultSku) {
            // Find the card that matches the default SKU
            defaultCard = Array.from(this.cards).find(card => {
                return card.dataset.sku === this.defaultSku;
            });
        }

        // If no card was found based on the metafield, use the first card
        if (!defaultCard && this.cards.length > 0) {
            defaultCard = this.cards[0]; // First card if no default is set
        }

        if (defaultCard) {
            this.selectCard(defaultCard); // Select the default card
        }
    }
}

// Retrieve the metafield value for the default collection method SKU from the data attribute
document.addEventListener('DOMContentLoaded', () => {
    const defaultCollectionMethod = document.getElementById('collection-methods-data')?.getAttribute('data-default-sku');
    console.log('default sku', defaultCollectionMethod)

    // Initialize the CollectionMethodSelector with the default SKU from the metafield
    new CollectionMethodSelector('.collection-method-container', defaultCollectionMethod);
});
